"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RBComContentTypeSchemas = void 0;
const apple_immersive_videos_schema_1 = require("./content/apple-immersive-videos.schema");
const audio_clips_schema_1 = require("./content/audio-clips.schema");
const audio_episodes_schema_1 = require("./content/audio-episodes.schema");
const audio_seasons_schema_1 = require("./content/audio-seasons.schema");
const audio_series_schema_1 = require("./content/audio-series.schema");
const author_profiles_schema_1 = require("./content/author-profiles.schema");
const collections_schema_1 = require("./content/collections.schema");
const editorial_lists_schema_1 = require("./content/editorial-lists.schema");
const energy_drinks_schema_1 = require("./content/energy-drinks.schema");
const episode_videos_schema_1 = require("./content/episode-videos.schema");
const event_details_schema_1 = require("./content/event-details.schema");
const event_profiles_schema_1 = require("./content/event-profiles.schema");
const event_seasons_schema_1 = require("./content/event-seasons.schema");
const event_series_schema_1 = require("./content/event-series.schema");
const _1_schema_1 = require("./content/ext/services/acast-audio/1.schema");
const _1_schema_2 = require("./content/ext/services/brackets-embed/1.schema");
const _1_schema_3 = require("./content/ext/services/cartoon-video/1.schema");
const _1_schema_4 = require("./content/ext/services/cloudinary-image/1.schema");
const _1_schema_5 = require("./content/ext/services/eventbrite/1.schema");
const _1_schema_6 = require("./content/ext/services/facebook-socialembed-post/1.schema");
const _1_schema_7 = require("./content/ext/services/facebook-sociallink/1.schema");
const _1_schema_8 = require("./content/ext/services/giphy-videoclip/1.schema");
const _1_schema_9 = require("./content/ext/services/immersive-3d-model-contentful/1.schema");
const _1_schema_10 = require("./content/ext/services/instagram-embed/1.schema");
const _1_schema_11 = require("./content/ext/services/instagram-sociallink/1.schema");
const _1_schema_12 = require("./content/ext/services/jotform-forms/1.schema");
const _1_schema_13 = require("./content/ext/services/media-partnerships-video/1.schema");
const _1_schema_14 = require("./content/ext/services/mediabase-delivery-agent-clip/1.schema");
const _2_schema_1 = require("./content/ext/services/mediabase-delivery-agent-clip/2.schema");
const _3_schema_1 = require("./content/ext/services/mediabase-delivery-agent-clip/3.schema");
const _1_schema_15 = require("./content/ext/services/megaphone-podcast-episode/1.schema");
const _1_schema_16 = require("./content/ext/services/mixcloud-audio/1.schema");
const _1_schema_17 = require("./content/ext/services/participant-gallery/1.schema");
const _1_schema_18 = require("./content/ext/services/pixlee-embed/1.schema");
const _1_schema_19 = require("./content/ext/services/platform-extension/1.schema");
const _1_schema_20 = require("./content/ext/services/rally-tv-video/1.schema");
const _1_schema_21 = require("./content/ext/services/rbmn-audio/1.schema");
const _1_schema_22 = require("./content/ext/services/rbmn-live/1.schema");
const _1_schema_23 = require("./content/ext/services/rbmn-video/1.schema");
const _1_schema_24 = require("./content/ext/services/redbull_com-vr-video/1.schema");
const _1_schema_25 = require("./content/ext/services/redbull_tv-linear-stream/1.schema");
const _1_schema_26 = require("./content/ext/services/redbull_tv-live/1.schema");
const _1_schema_27 = require("./content/ext/services/redbull_tv-video/1.schema");
const _1_schema_28 = require("./content/ext/services/riddle-embed/1.schema");
const _2_schema_2 = require("./content/ext/services/riddle-embed/2.schema");
const _1_schema_29 = require("./content/ext/services/servus-tv-livevideo/1.schema");
const _1_schema_30 = require("./content/ext/services/servus-tv-video/1.schema");
const _1_schema_31 = require("./content/ext/services/snapchat-sociallink/1.schema");
const _1_schema_32 = require("./content/ext/services/soundcloud-audio/1.schema");
const _2_schema_3 = require("./content/ext/services/soundcloud-audio/2.schema");
const _1_schema_33 = require("./content/ext/services/soundcloud-sociallink/1.schema");
const _1_schema_34 = require("./content/ext/services/spotify-audio/1.schema");
const _2_schema_4 = require("./content/ext/services/spotify-audio/2.schema");
const _1_schema_35 = require("./content/ext/services/spotify-sociallink/1.schema");
const _1_schema_36 = require("./content/ext/services/spreaker-audio/1.schema");
const _1_schema_37 = require("./content/ext/services/thing-link/1.schema");
const _1_schema_38 = require("./content/ext/services/tiktok-embed/1.schema");
const _1_schema_39 = require("./content/ext/services/tiktok-sociallink/1.schema");
const _1_schema_40 = require("./content/ext/services/twitch-livevideo/1.schema");
const _2_schema_5 = require("./content/ext/services/twitch-livevideo/2.schema");
const _1_schema_41 = require("./content/ext/services/twitch-sociallink/1.schema");
const _1_schema_42 = require("./content/ext/services/twitter-socialembed/1.schema");
const _1_schema_43 = require("./content/ext/services/twitter-sociallink/1.schema");
const _1_schema_44 = require("./content/ext/services/vimeo-video/1.schema");
const _1_schema_45 = require("./content/ext/services/vk-video/1.schema");
const _1_schema_46 = require("./content/ext/services/wrc-erc-standings-and-results/1.schema");
const _1_schema_47 = require("./content/ext/services/youtube-playlist/1.schema");
const _1_schema_48 = require("./content/ext/services/youtube-short/1.schema");
const _1_schema_49 = require("./content/ext/services/youtube-sociallink/1.schema");
const _1_schema_50 = require("./content/ext/services/youtube-video/1.schema");
const _1_schema_51 = require("./content/ext/services/zoe-embed/1.schema");
const external_persons_schema_1 = require("./content/external-persons.schema");
const external_teams_schema_1 = require("./content/external-teams.schema");
const externals_schema_1 = require("./content/externals.schema");
const films_schema_1 = require("./content/films.schema");
const image_galleries_schema_1 = require("./content/image-galleries.schema");
const images_schema_1 = require("./content/images.schema");
const immersive_3d_models_schema_1 = require("./content/immersive-3d-models.schema");
const judges_schema_1 = require("./content/judges.schema");
const live_videos_schema_1 = require("./content/live-videos.schema");
const locations_schema_1 = require("./content/locations.schema");
const misc_schema_1 = require("./content/misc.schema");
const occasion_campaigns_schema_1 = require("./content/occasion-campaigns.schema");
const occasions_schema_1 = require("./content/occasions.schema");
const onsite_promotions_schema_1 = require("./content/onsite-promotions.schema");
const partner_profiles_schema_1 = require("./content/partner-profiles.schema");
const person_profiles_schema_1 = require("./content/person-profiles.schema");
const photographers_schema_1 = require("./content/photographers.schema");
const playlists_schema_1 = require("./content/playlists.schema");
const preview_clips_schema_1 = require("./content/preview-clips.schema");
const project_profiles_schema_1 = require("./content/project-profiles.schema");
const rally_drivers_schema_1 = require("./content/rally-drivers.schema");
const rally_teams_schema_1 = require("./content/rally-teams.schema");
const recap_videos_schema_1 = require("./content/recap-videos.schema");
const results_standings_schema_1 = require("./content/results-standings.schema");
const seasons_schema_1 = require("./content/seasons.schema");
const shows_schema_1 = require("./content/shows.schema");
const stories_schema_1 = require("./content/stories.schema");
const tags_schema_1 = require("./content/tags.schema");
const team_profiles_schema_1 = require("./content/team-profiles.schema");
const trailer_videos_schema_1 = require("./content/trailer-videos.schema");
const tv_commercials_schema_1 = require("./content/tv-commercials.schema");
const tv_partner_channels_schema_1 = require("./content/tv-partner-channels.schema");
const video_3d_schema_1 = require("./content/video-3d.schema");
const video_channels_schema_1 = require("./content/video-channels.schema");
const videos_360_schema_1 = require("./content/videos-360.schema");
const videos_schema_1 = require("./content/videos.schema");
exports.RBComContentTypeSchemas = [
    apple_immersive_videos_schema_1.AppleImmersiveVideoSchema,
    audio_clips_schema_1.AudioClipSchema,
    audio_episodes_schema_1.AudioEpisodeSchema,
    audio_seasons_schema_1.AudioSeasonSchema,
    audio_series_schema_1.AudioSeriesSchema,
    author_profiles_schema_1.AuthorProfileSchema,
    collections_schema_1.ContentCollectionSchema,
    editorial_lists_schema_1.EditorialListSchema,
    energy_drinks_schema_1.EnergyDrinkSchema,
    episode_videos_schema_1.EpisodeVideoSchema,
    event_details_schema_1.EventDetailSchema,
    event_profiles_schema_1.EventProfileSchema,
    event_seasons_schema_1.EventSeasonSchema,
    event_series_schema_1.EventSeriesSchema,
    _1_schema_1.AcastPodcast1Schema,
    _1_schema_2.BracketsEmbed1Schema,
    _1_schema_3.CartoonVideo1Schema,
    _1_schema_4.CloudinaryImage1Schema,
    _1_schema_5.EventBriteCheckout1Schema,
    _1_schema_6.FacebookPost1Schema,
    _1_schema_7.FacebookFollow1Schema,
    _1_schema_8.Giphy1Schema,
    _1_schema_9.Immersive3DModelContentful1Schema,
    _1_schema_10.InstagramEmbed1Schema,
    _1_schema_11.InstagramFollow1Schema,
    _1_schema_12.JotForm1Schema,
    _1_schema_13.MediaPartnershipsVideo1Schema,
    _1_schema_14.MediabaseDeliveryAgentClips1Schema,
    _2_schema_1.MediabaseDeliveryAgentClips2Schema,
    _3_schema_1.MediabaseDeliveryAgentClips3Schema,
    _1_schema_15.MegaphonePodcastEpisode1Schema,
    _1_schema_16.MixcloudAudio1Schema,
    _1_schema_17.ParticipantGallery1Schema,
    _1_schema_18.PixleeEmbed1Schema,
    _1_schema_19.PlatformExtension1Schema,
    _1_schema_20.RallyTvVideo11Schema,
    _1_schema_21.RBMNAudio1Schema,
    _1_schema_22.RBMNLive1Schema,
    _1_schema_23.RBMNVideo1Schema,
    _1_schema_24.BrightcoveVRVideo1Schema,
    _1_schema_25.RedBullTVLinearStream1Schema,
    _1_schema_26.RedBullTVLiveVideostream1Schema,
    _1_schema_27.RedBullTVVideo1Schema,
    _1_schema_28.RiddleEmbed1Schema,
    _2_schema_2.RiddleEmbed2Schema,
    _1_schema_29.ServusTVLiveVideo1Schema,
    _1_schema_30.ServusTVVideo1Schema,
    _1_schema_31.Snapchat1Schema,
    _1_schema_32.SoundcloudAudio1Schema,
    _2_schema_3.SoundcloudAudio2Schema,
    _1_schema_33.SoundcloudSocialLink1Schema,
    _1_schema_34.Spotify1Schema,
    _2_schema_4.Spotify2Schema,
    _1_schema_35.SpotifySocialLink1Schema,
    _1_schema_36.SpreakerAudio1Schema,
    _1_schema_37.ThingImage1Schema,
    _1_schema_38.TikTokEmbed1Schema,
    _1_schema_39.TikTokSocialLink1Schema,
    _1_schema_40.TwitchLiveVideo1Schema,
    _2_schema_5.TwitchLiveVideo2Schema,
    _1_schema_41.TwitchSocialLink1Schema,
    _1_schema_42.TwitterTweetEmbed1Schema,
    _1_schema_43.TwitterFollow1Schema,
    _1_schema_44.VimeoVideo1Schema,
    _1_schema_45.VKVideo1Schema,
    _1_schema_46.WrcErcStandingsAndResults1Schema,
    _1_schema_47.YoutubePlaylist1Schema,
    _1_schema_48.YoutubeShort1Schema,
    _1_schema_49.YoutubeSocialLink1Schema,
    _1_schema_50.YoutubeVideo1Schema,
    _1_schema_51.ZoeEmbed1Schema,
    external_persons_schema_1.ExternalPersonSchema,
    external_teams_schema_1.ExternalTeamSchema,
    externals_schema_1.ExternalContentSchema,
    films_schema_1.FilmSchema,
    image_galleries_schema_1.ImageGallerySchema,
    images_schema_1.ImageSchema,
    immersive_3d_models_schema_1.Immersive3DModelSchema,
    judges_schema_1.JudgeSchema,
    live_videos_schema_1.LiveVideoSchema,
    locations_schema_1.LocationSchema,
    misc_schema_1.MiscSchema,
    occasion_campaigns_schema_1.OccasionCampaignSchema,
    occasions_schema_1.OccasionSchema,
    onsite_promotions_schema_1.OnsitePromotionSchema,
    partner_profiles_schema_1.PartnerProfileSchema,
    person_profiles_schema_1.PersonProfileSchema,
    photographers_schema_1.PhotographerSchema,
    playlists_schema_1.PlaylistSchema,
    preview_clips_schema_1.PreviewClipSchema,
    project_profiles_schema_1.ProjectProfileSchema,
    rally_drivers_schema_1.RallyDriverSchema,
    rally_teams_schema_1.RallyTeamSchema,
    recap_videos_schema_1.RecapVideoSchema,
    results_standings_schema_1.ResultsAndStandingsSchema,
    seasons_schema_1.SeasonSchema,
    shows_schema_1.ShowSchema,
    stories_schema_1.StorySchema,
    tags_schema_1.TagSchema,
    team_profiles_schema_1.TeamProfileSchema,
    trailer_videos_schema_1.TrailerVideoSchema,
    tv_commercials_schema_1.TvCommercialSchema,
    tv_partner_channels_schema_1.TvPartnerChannelSchema,
    video_3d_schema_1.Video3DSchema,
    video_channels_schema_1.VideoChannelSchema,
    videos_360_schema_1.Video360Schema,
    videos_schema_1.VideoSchema
];
//# sourceMappingURL=data:application/json;base64,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